import { useEffect, useState } from "react";

/**
 * Khung xanh đầu trang /lo-trinh, cùng kiểu với khung của /cong-cu
 * (CongCuBanDo): mỗi cột là một trạm, mỗi ô vuông là một việc của trạm đó,
 * màu theo trạm. Ô đặc là việc đã có kết quả, ô viền là việc chưa làm.
 * Chạm một cột để xem việc của trạm đó ở bảng bên dưới (onChon).
 *
 * cacCot: [{ tram, mau, tt: ["xong" | "co-ket-qua" | "chua"] theo việc }]
 * moc: id trạm có cờ "Bạn" (trạm gợi ý hoặc trạm đang làm), có thể null.
 */
export default function LoTrinhKhung({ cacCot, dangChon, moc, onChon, chan }) {
  const [hien, setHien] = useState(true);
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    setHien(false);
    const id = requestAnimationFrame(() => requestAnimationFrame(() => setHien(true)));
    return () => cancelAnimationFrame(id);
  }, []);

  const tongViec = cacCot.reduce((a, c) => a + c.tram.viec.length, 0);

  return (
    <div className={"ccb ltk" + (hien ? " hien" : "")}>
      <div className="ccb-dau">
        <span>{cacCot.length} trạm, {tongViec} việc</span>
        <span className="ccb-goi-y">Chạm để xem việc</span>
      </div>
      <div className="ccb-cot" role="group" aria-label="Chọn trạm">
        {cacCot.map(({ tram, mau, tt }, ci) => {
          const coKq = tt.filter((x) => x !== "chua").length;
          return (
            <button
              key={tram.id}
              type="button"
              className={dangChon === tram.id ? "dang" : ""}
              aria-pressed={dangChon === tram.id}
              onClick={() => onChon(tram.id)}
              aria-label={`Trạm ${tram.so}: ${tram.ten}, ${tram.viec.length} việc`}
              style={{ "--mau": mau }}
            >
              <span className="ccb-o ltk-o" aria-hidden="true">
                {moc === tram.id && <span className="ltk-co">Bạn</span>}
                {tram.viec.map((v, i) => (
                  <i key={v.ten} className={tt[i] !== "chua" ? "co" : ""} style={{ "--d": `${ci * 80 + i * 60}ms` }}>
                    {tt[i] !== "chua" ? "✓" : i + 1}
                  </i>
                ))}
              </span>
              <span className="ccb-ten">
                <b>Trạm {tram.so}</b>
                <small className="ccb-ten-dai">{tram.ten}</small>
                <small>{coKq ? `${coKq}/${tram.viec.length} việc có kết quả` : `${tram.viec.length} việc`}</small>
              </span>
            </button>
          );
        })}
      </div>
      <p className="ccb-chan">{chan}</p>
    </div>
  );
}
